import { motion } from "framer-motion";
import { fadeUp, VIEWPORT_SM } from "./primitives";
import FooterBottom from "@/components/FooterBottom";
import { FooterNav } from "@/components/navigation/SiteNav";

export const LandingFooter = () => (
  <footer
    data-testid="site-footer"
    className="zone-graphite bg-paper relative border-t border-ink/10 overflow-hidden"
  >
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
    <img
      src="/provena-logo.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none select-none absolute -right-16 -bottom-20 w-72 opacity-[0.04]"
      draggable="false"
    />
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={VIEWPORT_SM}
      variants={fadeUp}
      className="relative max-w-7xl mx-auto px-5 md:px-12 py-14"
    >
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <img
          src="/provena-logo-relief.png"
          alt="Provena Registry"
          className="h-20 w-auto object-contain self-start"
        />
        <FooterNav />
      </div>
      <FooterBottom />
    </motion.div>
  </footer>
);

export default LandingFooter;
